import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { LocationWithPlan } from '../../../../types';

type CellParams = ICellRendererParams<LocationWithPlan>;

@Component({
  selector: 'app-pan-cell-billing-portal-cell-attributes',
  imports: [UiModule, MatTooltipModule, RouterModule, MatIconModule],
  templateUrl: './billing-portal-cell-attributes.component.html',
  styleUrl: './billing-portal-cell-attributes.component.scss',
})
export class CellBillingPortalCellAttributesComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
